import 'css-chunksrc/client/pages/eventPage/styles.scss';export default {
  "event": "_event_i688a_1",
  "eventLoading": "_eventLoading_i688a_9",
  "loader": "_loader_i688a_15",
  "loaderMain": "_loaderMain_i688a_29",
  "main": "_main_i688a_36",
  "content": "_content_i688a_43",
  "secondaryCriteria": "_secondaryCriteria_i688a_49",
  "label": "_label_i688a_54",
  "row": "_row_i688a_60",
  "configurationIconBox": "_configurationIconBox_i688a_71",
  "configurationIcon": "_configurationIcon_i688a_71",
  "scrollWrapper": "_scrollWrapper_i688a_89",
  "timeline": "_timeline_i688a_98",
  "timestamp": "_timestamp_i688a_105",
  "comments": "_comments_i688a_116",
  "header": "_header_i688a_124",
  "contentHeader": "_contentHeader_i688a_137",
  "title": "_title_i688a_145",
  "rightContent": "_rightContent_i688a_153",
  "profileNavigation": "_profileNavigation_i688a_160",
  "contextualMenu": "_contextualMenu_i688a_168",
  "contentProjectRedirection": "_contentProjectRedirection_i688a_176",
  "contentModal": "_contentModal_i688a_180",
  "list": "_list_i688a_187",
  "folderIcon": "_folderIcon_i688a_194",
  "icon": "_icon_i688a_198",
  "scenePlaceholder": "_scenePlaceholder_i688a_204"
};